import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Center, SegmentedControl, Stack } from '@mantine/core';
import Editable from '../../../Atoms/inputs/Editable';
import { HTMLEditableText } from '../../../Atoms/inputs/HTMLEditableText';
import { EditableDivInput } from '../../../Atoms/inputs/EditableDivInput';
import { HtmlFormatter } from '../../../Atoms/Formatter/HtmlFormatter';

const editorOptions = [
  { label: 'HTML', value: 'HTML_Editor' },
  { label: 'Text', value: 'Text_Editor' },
];

const SignatureEditor = ({ signature, onChange, allowPlaceholders = true }) => {
  const [editor, setEditor] = useState('Text_Editor');
  const value = signature || '';
  const EditFormatter = editor === 'HTML_Editor' ? HTMLEditableText : EditableDivInput;

  const changeSignature = (patch) => Promise.resolve(onChange(patch.signature || ''));

  return (
    <Stack spacing="xs">
      <Center>
        <SegmentedControl color="blue" value={editor} onChange={setEditor} data={editorOptions} />
      </Center>
      <Editable
        value={value}
        onChange={changeSignature}
        edit={EditFormatter}
        label={HtmlFormatter}
        patchField="signature"
        name="signature"
        big
        editOnly
        settings={allowPlaceholders}
        preserveHtmlFormatting
        deferFinish
      />
    </Stack>
  );
};

SignatureEditor.propTypes = {
  signature: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  allowPlaceholders: PropTypes.bool,
};

SignatureEditor.defaultProps = {
  signature: '',
  allowPlaceholders: true,
};

export default SignatureEditor;
